<template>
  <div class="about-culture">
    <div class="container">
      <div class="about-subject">
        <div class="about-title">品牌文化</div>
        <div class="about-describe">
          <p>懒精灵FREEGENIUS起源</p>
          <p class="p-text">Genlus来自古罗马深化中的守护神，懒精灵FREEGENIUS致力于健康、非凡、卓越的生活空间，用艺术精神雕琢你心底最温柔安全的地方，做品质艺术生活的守护神。</p>
        </div>
        <div class="about-describe">
          <p>触手可及的艺术空间</p>
          <p class="p-text">
            懒精灵艺术墙艺集壁纸、乳胶漆、硅藻泥、微水泥等产品等优点于一身。具有先进等抗污性，防潮防霉、耐划伤、有弹性等物理性能。懒精灵美学库、懒精灵VR软件解决你墙艺装修方案选择困难；懒精灵工匠会员助您简单、快速施工，避免复杂耗时的施工；让你远离家居日常清洁，维护难烦恼。触手可及的艺术空间————即刻轻松享受艺术涂料，微品质生活提供简单的选择，是懒精灵的品牌主张。
          </p>
        </div>
      </div>
      <div class="about-img"></div>
    </div>
  </div>
</template>

<script>

export default {

}
</script>

<style lang="less" scoped>
@height: 750px;
.about-culture {
  min-height: @height;
  overflow: hidden;
  background: url(https://img.xnxx.mengcreate.com/LJL/about2.png);
  background-size: cover;
  background-position: center;
  .container {
    height: @height;

    position: relative;
    color: #74b828;
    display: flex;
    align-items: center;
    .about-subject {
      flex: 1;
      .about-title {
        display: inline-block;
        font-weight: 500;
        padding: 0.2rem;
        border-bottom: 1px #74b828 solid;
        margin-bottom: 3rem;
      }
      .about-describe {
        font-size: 16px;
        margin-bottom: 4rem;
        p:nth-child(1) {
          font-size: 2rem;
          font-weight: 600;
          color: #74b828;
        }
        .p-text {
          color: #fff;
          line-height: 1.8rem;
        }
      }
    }
    .about-img {
      flex: 1;
    }
  }
}
@media only screen and (max-width: 786px) {
  .about-culture {
    .container {
      max-width: 786px;
      width: 100%;
      padding: 0 20px;
      .about-subject {
        flex: auto;
      }
      .about-img {
        flex: auto;
      }
      // flex-direction: column;
    }
  }
}
</style>